import { useEffect, useState } from "react";
import { isNative } from "@origin-digital/platform-helpers";
import { authUser } from "@origin-digital/event-dispatcher";
import { config } from "../../config";

interface AuthStatus {
  isAuth: boolean;
  isNativePlatform: boolean;
  isResolved: boolean;
}

export const useAuthStatus = (): AuthStatus => {
  const isNativePlatform = isNative();
  const [isAuth, setIsAuth] = useState(isNativePlatform);
  const [isResolved, setIsResolved] = useState(isNativePlatform);

  useEffect(() => {
    if (isNativePlatform) return;

    let cancelled = false;

    (async () => {
      const authResult = await authUser({
        auth0Environment: config.env as EnvironmentNames,
      });
      if (cancelled) return;
      setIsAuth(authResult?.isAuth ?? false);
      setIsResolved(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [isNativePlatform]);

  return { isAuth, isNativePlatform, isResolved };
};
